/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-15 15:00:00
 *
 *******************************************************/
// @flow

import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';
import { processRes } from 'src/helpers/actions-helper';

import apiService from 'src/services/api-service';
import {
  SI_GET_ALL_THEMES_REQUEST,
  SI_GET_ALL_THEMES_SUCCESS,
  SI_GET_ALL_THEMES_FAILURE,
  SI_UPDATE_ALL_THEMES
} from 'stores/flow-type/shopify-integration/theme.type';

/**
 * call to get list of all themes api (v3 api, v3 of update phase, not theme v3)
 * @return {object} The RSAA object for API middleware
 */
export const getAllThemes = (i18n: I18n) => {
  return apiService.sendRequest('shopify-integration.theme.list-themes', {}, [
    SI_GET_ALL_THEMES_REQUEST,
    {
      type: SI_GET_ALL_THEMES_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: SI_GET_ALL_THEMES_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.ThemeSetup.Actions.getAllThemes'),
          i18n
        )
    }
  ]);
};

/**
 * Call to update all themes
 * @returns An object with a type and a payload.
 */
export const updateAllThemes = (data: any) => {
  return { type: SI_UPDATE_ALL_THEMES, payload: { data } };
};
